import React from 'react';
import { useStyletron } from 'baseui';
import { Select } from 'baseui/select';
import { Button } from 'baseui/button';
import { DatePicker } from 'baseui/datepicker';
import { TimePicker } from 'baseui/timepicker';
import dayjs from 'dayjs';
import {
	FEATURE_TYPE_OPTIONS,
	PAYMENT_MODE_CHECKOUT_OPTIONS,
	SCHEDULE_OPTIONS,
	PAYMENT_MODE_PAYOUT_OPTIONS,
	EFeatureType,
	EPayoutModeType,
	EDowntimeFetchStatus,
	DOWNTIME_OPTIONS
} from '../../utils/constants';

const ScheduledDowntimeFilter = (props: any) => {
	const { handleFormSubmit } = props;
	const [css] = useStyletron();
	const [featureType, setFeatureType] = React.useState<any>({ id: EFeatureType.PAYOUT, label: 'PAYOUT' });
	const [paymentMode, setPaymentMode] = React.useState<any>({ id: EPayoutModeType.UPI, label: 'UPI' });
	const [isActive, setIsActive] = React.useState<any>({ id: true, label: 'True' });
	const [schedule, setSchedule] = React.useState<any>({ id: EDowntimeFetchStatus.UPCOMING, label: 'UPCOMING' });
	const [startDate, setStartDate] = React.useState<any>(new Date());
	const [startTime, setStartTime] = React.useState<any>(new Date());
	return (
		<>
			<div className={css({ display: 'flex', width: '100%', justifyContent: 'left', margin: 'auto', background: 'white' })}>
				<div
					className={css({
						width: '230px !important',
						textAlign: 'center',
						padding: '10px 10px'
					})}>
					Feature Type{' '}
					<span
						className={css({
							color: 'red'
						})}>
						*
					</span>
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<Select
							options={FEATURE_TYPE_OPTIONS}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => {
								setFeatureType(option);
								setPaymentMode([]);
							}}
							value={[featureType]}
						/>
					</div>
				</div>
				<div
					className={css({
						width: '230px !important',
						textAlign: 'center',
						padding: '10px 10px'
					})}>
					Date{' '}
					<span
						className={css({
							color: 'red'
						})}>
						*
					</span>
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<DatePicker
							formatString='yyyy-MM-dd'
							value={startDate}
							onChange={({ date }) => setStartDate(Array.isArray(date) ? date : [date])}
						/>
					</div>
				</div>
				<div
					className={css({
						width: '230px !important',
						textAlign: 'center',
						padding: '10px 10px'
					})}>
					Time{' '}
					<span
						className={css({
							color: 'red'
						})}>
						*
					</span>
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<TimePicker value={startTime} onChange={setStartTime} />
					</div>
				</div>
				<div
					className={css({
						width: '230px !important',
						textAlign: 'center',
						padding: '10px 10px'
					})}>
					Payment Mode{' '}
					<span
						className={css({
							color: 'red'
						})}>
						*
					</span>
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<Select
							options={featureType.id === 'checkout' ? PAYMENT_MODE_CHECKOUT_OPTIONS : PAYMENT_MODE_PAYOUT_OPTIONS}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => setPaymentMode(option)}
							value={[paymentMode]}
						/>
					</div>
				</div>
				<div
					className={css({
						width: '230px !important',
						textAlign: 'center',
						padding: '10px 10px'
					})}>
					Downtime
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<Select
							options={DOWNTIME_OPTIONS as any}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => setIsActive(option)}
							value={[isActive]}
						/>
					</div>
				</div>
				<div
					className={css({
						width: '230px !important',
						textAlign: 'center',
						padding: '10px 10px'
					})}>
					Schedule{' '}
					<span
						className={css({
							color: 'red'
						})}>
						*
					</span>
					<div
						className={css({
							borderStyle: 'solid',
							borderColor: 'black'
						})}>
						<Select
							options={SCHEDULE_OPTIONS}
							labelKey='label'
							valueKey='id'
							searchable={false}
							clearable={false}
							onChange={({ option }) => setSchedule(option)}
							value={[schedule]}
						/>
					</div>
				</div>
				<div
					className={css({
						textAlign: 'center',
						padding: '32px 10px'
					})}>
					<Button
						size='default'
						onClick={() => {
							const filterData: any = {
								startDate: dayjs(Array.isArray(startDate) ? startDate[0] : startDate).format('YYYY-MM-DD'),
								startTime: dayjs(new Date(Number(startTime))).format('HH:mm:ss'),
								schedule: schedule?.id,
								featureType: featureType?.id,
								isActive: isActive?.id,
								paymentMode: paymentMode?.id
							};
							handleFormSubmit(filterData);
						}}>
						Submit
					</Button>
				</div>
			</div>
		</>
	);
};

export default ScheduledDowntimeFilter;
